export enum IconSize {
  xsmall = 'xsmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export enum IconPosition {
  left = 'left',
  right = 'right',
}
